import React from 'react';
import { CallsInsightHub } from './components/CallsInsightHub/CallsInsightHub';
export function App() {
  return <CallsInsightHub data-id="element-0" data-mp="35bab1emx5oar" />;
}